import { useCallback, useEffect, useState } from 'react';
import { useWagmiAuth } from 'app/providers';
import { packagesModel } from 'entities/mine-package';
import { paymentModel } from 'entities/payment';
import { useAppDispatch } from 'shared';
import { Address } from 'viem';

export const useInitWidgetData = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { state: authState } = useWagmiAuth();

  const fetchPaymentData = useCallback(async () => {
    setIsLoading(true);
    try {
      await Promise.all([
        dispatch(paymentModel.thunks.getUserPaymentWallets()).unwrap(),
        dispatch(paymentModel.thunks.getNetworks()),
        dispatch(packagesModel.thunks.getOwnedNft(authState.address as Address)).unwrap(),
      ]);
      await dispatch(paymentModel.thunks.getPaymentRequest());
    } finally {
      setIsLoading(false);
    }
  }, [authState.address, dispatch]);

  useEffect(() => {
    if (authState.isAuthorized) {
      fetchPaymentData();
    }
  }, [authState.isAuthorized, fetchPaymentData]);

  return {
    isLoading,
  };
};
